import { Css } from "~generated/css";
import { CheckoutConfigStatus, Maybe } from "~generated/graphqlTypes";
import { dateFormatter } from "~utils";

function DateRow({ label, date, isRed }: { label: string; date: Maybe<Date>; isRed?: boolean }) {
  if (!date) return null;
  return (
    <div>
      {label}: <span css={isRed ? Css.fw500.red600.$ : Css.fw500.$}>{dateFormatter(date, "MMMM d, yyyy")}</span>
    </div>
  );
}

type PrintHeaderProps = {
  status: CheckoutConfigStatus;
  createdAt: Maybe<Date>;
  reservedAt: Maybe<Date>;
  configurationName?: string | null;
  expiredAt: Maybe<Date>;
  customerEmail: Maybe<string>;
};

export const PrintHeader = ({
  status,
  createdAt,
  reservedAt,
  configurationName,
  expiredAt,
  customerEmail,
}: PrintHeaderProps) => {
  const [isDraft, isExpired] = [CheckoutConfigStatus.Draft, CheckoutConfigStatus.Expired].map((s) => status === s);
  return (
    <>
      <div css={Css.z1.w100.df.fg1.aic.jcsb.my1.$}>
        <img width="153" height="26" src="/logo.svg" alt="Homebound" />
      </div>
      <div css={Css.df.w100.jcsb.t16.gray800.fw200.$}>
        <div css={Css.df.fdc.gap1.$}>
          <div>
            Build: <span css={Css.t18.fw500.$}>{configurationName ?? "Custom"}</span>
          </div>
          {isDraft && <div css={Css.fw500.red600.$}>Pricing Not Reserved</div>}
          {customerEmail && (
            <div>
              Homeowner Email: <span css={Css.fw500.$}>{customerEmail}</span>
            </div>
          )}
          <div css={Css.df.fdc.gap1.$}>
            {isDraft && <DateRow label="Created" date={createdAt} />}
            {!isDraft && <DateRow label="Reserved" date={reservedAt} />}
            {!isDraft && <DateRow label={`Expire${isExpired ? "d" : "s"}`} date={expiredAt} isRed />}
          </div>
        </div>
      </div>
    </>
  );
};
